module.exports = __webpack_public_path__ + "static/paquete-4-80dfe304fce09ee5bb6f67a3fecd37af.svg";